import {Input as InputPrimitive} from "@base-ui/react/input"
import {clsx} from "clsx"
import styles from "./Input.module.css"

function Input({className, type, ...props}: InputPrimitive.Props) {
	return (
		<InputPrimitive
			type={type}
			data-slot="input"
			className={clsx(styles.root, className)}
			{...props}
		/>
	)
}

export {Input}
